export default __webpack_public_path__ + "static/media/svgsprite.978b9231.svg";